import { MetricsService } from "../core/services/metrics.service";
import { SICallTypes } from "../features/service-insights/types/service-insight-types";
import { Filters } from "./filter-model";
import { ServiceCustomerFilterOptions } from "./service-customer-model";


export class MetricDetailsRequest {
    filters: Filters | undefined;
    serviceType: string | undefined;
    metricDetailType: SICallTypes | undefined;
    observationName: string | undefined; //KIT/LDY/PS Readings
    private _limit: number;
    private _page: number;
    private _sortBy: string;
    private _sortOrder: string;
    private _graphDetailFilter: string = "";
    private _serviceCustomerFilters: ServiceCustomerFilterOptions

    constructor(
        filters?: Filters,
        serviceType?: string,
        metricDetailType?: SICallTypes,
        observationName?: string,
        limit=25, page=1,
        sortBy='',
        sortOrder='',
        graphDetailFilter: string = "",
        serviceCustomerFilters?: ServiceCustomerFilterOptions
    ){
        this.filters = filters;
        this.serviceType = serviceType;
        this.metricDetailType = metricDetailType;
        this._limit = limit;
        this._page = page;
        this._sortBy = sortBy;
        this._sortOrder = sortOrder;
        this.observationName = observationName;
        this._graphDetailFilter = graphDetailFilter;
        this._serviceCustomerFilters = serviceCustomerFilters ??
        {
            accountNumber: [],
            accountName: [],
            country: [],
            state: [],
            city: [],
            zipCode: [],
            recurringIssue: [],
        };
        if(observationName!=null){
            var metricsService = new MetricsService
        }
    }

    public get limit() {
        return this._limit;
    }

    public get page() {
        return this._page;
    }

    public get sortBy() {
        return this._sortBy;
    }

    public get sortOrder() {
        return this._sortOrder;
    }

    public get graphDetailFilter() {
        return this._graphDetailFilter;
    }

    public get serviceCustomerFilters() {
        return this._serviceCustomerFilters;
    }

    public set limit(limit: number) {
        this._limit = limit;
    }

    public set page(page: number) {
        this._page = page;
    }

    public set sortBy(name: string) {
        this._sortBy = name;
    }

    public set sortOrder(order: string) {
        this._sortOrder = order;
    }

    public set graphDetailFilter(graphDetailFilter: string) {
        this._graphDetailFilter = graphDetailFilter;
    }

    public set serviceCustomerFilters(serviceCustomerFilters: ServiceCustomerFilterOptions) {
        this._serviceCustomerFilters = serviceCustomerFilters;
    }
}

export class ServiceCallDetails {
    accountNumber: string;
    unitNumber: string;
    accountName: string;
    shippingCity: string;
    shippingState: string;
    workOrderNumber: string;
    callReason: string;
    status: string;
    endDate: string;
    callSummaryNotes: string;
    quickCallComments: string;
    esrCallComments: string;
    installationCallComments;
    trainingCallComments;

    constructor(
        accountNumber: string,
        unitNumber: string,
        accountName: string,
        shippingCity: string,
        shippingState: string,
        workOrderNumber: string,
        callReason: string,
        status: string,
        endDate: string,
        callSummaryNotes: string,
        quickCallComments: string,
        esrCallComments: string,
        installationCallComments: string,
        trainingCallComments: string
        ){
        this.accountNumber = accountNumber;
        this.unitNumber = unitNumber;
        this.accountName = accountName;
        this.shippingCity = shippingCity;
        this.shippingState = shippingState;
        this.workOrderNumber = workOrderNumber;
        this.callReason = callReason;
        this.status = status;
        this.endDate = endDate;
        this.callSummaryNotes = callSummaryNotes;
        this.quickCallComments = quickCallComments;
        this.esrCallComments = esrCallComments;
        this.installationCallComments = installationCallComments;
        this.trainingCallComments = trainingCallComments;
    }
};
